$(document).ready(() => {
    window.ProductPricing.initInsightsPricing(SaleHoo.InsightsPricing || {})

    const searchParams = new URLSearchParams(document.location.search);

    if (searchParams.get('success') === null) {
        $('#signup-container').removeClass('d-none');
        $('#confirmed-container').addClass('d-none');
    } else {
        $('#signup-container').addClass('d-none');
        $('#confirmed-container').removeClass('d-none');
    }

    function init() {
        $.ajax({ url: '/insights/seoReports/highlights', dataType: 'json' }).then((result) => {
            let $highlights = $('#insightsHighlights');

            $highlights.empty();

            result.forEach(function (item, index) {
                let $highlight = $('<div>', {class: index < 8 ? 'col-xl-3 col-lg-6 col-md-6' : 'col-xl-3 col-lg-6 col-md-6 d-md-block d-none'})
                    .append(
                        $('<div>', {class: 'card p-4 border-0 rounded-4 h-100'})
                            .append(
                                $('<h5>', {class: 'mb-0'})
                                    .append($('<a href="/trends/' + item.slug + '">', {class: 'link-hover-underline', href: ''}).text(ucWords(item.title)))
                            )
                            .append(
                                $('<div>', {class: 'my-4 chart-container'})
                                    .attr('data-chart', JSON.stringify(item.values))
                                    .attr('data-labels', JSON.stringify(item.labels))
                                    .append(
                                        $('<canvas>')
                                    )
                            )
                            .append(
                                $('<div>', {class: 'd-flex align-items-end justify-content-between mb-4'})
                                    .append(
                                        $('<span>', {class: 'badge label rounded-pill ' + pillClass(item.humanTrend) + ' iconEnd sm'}).text(trendText(item.humanTrend))
                                    )
                                    .append(
                                        $('<div>', {class: 'd-flex flex-column'})
                                            .append($('<span>', {class: item.humanTrend > 0 ? 'font-size-14 font-weight-semibold text-success' : 'font-size-14 font-weight-semibold text-danger'}).text(item.humanTrend > 0 ? '+' + item.humanTrend + '%' : item.humanTrend + '%'))
                                            .append($('<span>', {class: 'font-size-11 opacity-60 mt-n1'}).text('Growth'))
                                    )
                            )
                            .append(
                                $('<div>', {class: 'opacity-80 font-size-14 highlight-summary'})
                                    .html(item.summary)
                            )
                    );

                $highlights.append($highlight);
            });

            $('.ideas button').on('click', function () {
                $('#insightsHighlights > div').removeClass('d-none');

                $(this).hide();
            });

            initCharts();
        });
    }

    function trendThreshold(trendValue) {
        if (trendValue) {
            let trend = trendValue / 100;

            if (trend > 0.5) {
                return 2;
            }

            if (trend > 0) {
                return 1;
            }

            if (trend < -0.5) {
                return -2;
            }

            if (trend < 0) {
                return -1;
            }

            return 0;
        }
    }

    function trendText(trendValue) {
        switch (trendThreshold(trendValue)) {
            case 2:
                return "Increasing Fast";
            case 1:
                return "Increasing";
            case 0:
                return "Flattened";
            case -1:
                return "Decreasing";
            case -2:
                return "Decreasing Fast";
        }
    }

    function pillClass(trendValue) {
        switch (trendThreshold(trendValue)) {
            case 2:
                return "yellow ico-arrowUpYellow";
            case 1:
                return "green ico-arrowUpGreen";
            case 0:
                return "gray ico-dash";
            case -1:
                return "orange-2 ico-arrowDownOrange2";
            case -2:
                return "orange ico-arrowDownOrange";
        }
    }

    function ucWords(string) {
        const words = string.split(" ");

        return words.map((word) => {
            return word[0].toUpperCase() + word.substring(1);
        }).join(" ");
    }

    function initCharts() {
        Chart.defaults.plugins.legend.display = false;

        $('.chart-container').each(function () {
            const $container = $(this);
            const chart = new Chart($container.find('canvas'), {
                type: 'line',
                data: {
                    labels: JSON.parse($container.attr('data-labels')),
                    datasets: [{
                        data: JSON.parse($container.attr('data-chart')),
                        borderColor: '#0072D6',
                        borderWidth: 3,
                        pointRadius: 0,
                        hoverRadius: 8,
                        fill: false
                    }]
                },
                options: {
                    animation: false,
                    scales: {
                        x: {
                            border: {
                                display: false
                            },
                            title: {
                                display: false
                            },
                            ticks: {
                                display: false
                            },
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            border: {
                                display: false
                            },
                            title: {
                                display: false
                            },
                            ticks: {
                                display: false
                            },
                            grid: {
                                display: false
                            },
                            min: 0,
                            suggestedMax: 50
                        }
                    },
                    plugins: {
                        tooltip: {
                            displayColors: false,
                            callbacks: {
                                label: (ctx) => {
                                    let val = ctx.parsed.y;
                                    val = val/(50)*100;

                                    let amountText = "<5%";
                                    if (val > 80) {
                                        amountText = ">80%";
                                    } else if (val > 20) {
                                        // Round to nearest 10%
                                        val = (Math.round(val/10))*10;
                                        amountText = "~" + val + "%";
                                    } else if (val > 5) {
                                        // Round to nearest 5 here
                                        val = (Math.round(val/5))*5;
                                        amountText = "~" + val + "%";
                                    }

                                    return [
                                        amountText + " of globally top-selling",
                                        "product performance"
                                    ];
                                }
                            }
                        }
                    }
                }
            });
        });
    }

    init();
});